import { MediaType } from '../../../../Chat.enum.ts';
import { fileExtensionMap, mediaTypeMap } from './Thumbnail.constants.ts';
import { tMetaData } from './Thumbnail.types.ts';

export function getFileType(mediaType: string): MediaType {
  return mediaTypeMap[mediaType] || MediaType.DOCUMENT;
}

export function isAudio(mediaType: string): boolean {
  return getFileType(mediaType) === MediaType.AUDIO;
}

export function isVideo(mediaType: string): boolean {
  return getFileType(mediaType) === MediaType.VIDEO;
}

export function isImage(mediaType: string): boolean {
  return getFileType(mediaType) === MediaType.IMAGE;
}

export function isDocument(mediaType: string): boolean {
  return getFileType(mediaType) === MediaType.DOCUMENT;
}

export function isPdf(mediaType: string): boolean {
  return getFileType(mediaType) === MediaType.PDF;
}

export function isDocumentOrPdf(mediaType: string): boolean {
  const type = getFileType(mediaType);

  return (
    type === MediaType.DOCUMENT ||
    type === MediaType.PDF ||
    type === MediaType.CSV
  );
}

export function isImageOrVideo(mediaType: string): boolean {
  const type = getFileType(mediaType);

  return type === MediaType.IMAGE || type === MediaType.VIDEO;
}

export function isVideoOrAudio(mediaType: string): boolean {
  const type = getFileType(mediaType);

  return type === MediaType.VIDEO || type === MediaType.AUDIO;
}

export function isImageOrVideoOrAudio(mediaType: string): boolean {
  const type = getFileType(mediaType);

  return (
    type === MediaType.IMAGE ||
    type === MediaType.VIDEO ||
    type === MediaType.AUDIO
  );
}

export function truncateText(text: string, maxSize: number): string {
  if (text.length <= maxSize) {
    return text;
  }
  return text.substring(0, maxSize) + '...';
}

export function getFileMetaData(fileName: string): tMetaData {
  const extension = fileName.slice(fileName.lastIndexOf('.')).toLowerCase();
  return (
    fileExtensionMap[extension] || {
      extension,
      mimeType: 'application/pdf', // A generic MIME type.
      mediaType: MediaType.DOCUMENT,
    }
  );
}
